var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWorkable = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.293 217.08C240.13 203.246 244.13 190.931 243.98 181.412C243.796 169.73 239.146 161.029 232.298 155.263C211.679 137.941 171.074 147.183 171.626 181.959C171.828 195.08 178.198 212.062 194.766 232.543C194.766 232.543 204.002 224.273 206.028 216.856C162.045 157.081 254.5 153.824 208.503 220.101C208.503 220.101 203.185 228.75 196.418 234.545C182.071 248.069 169.083 252.345 157.758 250.486C118.436 244.041 112.163 185.366 109.251 150.481H80.38L80.3569 151.643V158.163C81.8647 227.392 130.854 323.697 209.147 247.948C216.899 240.179 221.313 233.993 221.313 233.993C225.287 228.568 228.953 222.923 232.293 217.086V217.08ZM298.823 186.994C293.546 227.646 269.997 261.99 234.491 243.08C233.788 244.047 233.055 244.991 232.293 245.911C228.907 249.906 225.094 253.519 220.921 256.684C220.821 256.628 220.715 256.584 220.605 256.551C224.518 259.009 228.42 260.965 232.293 262.456C276.143 279.403 316.144 237.498 320 185.101L299.398 184.18C299.141 185.104 298.949 186.044 298.823 186.994Z",
    fill: "#00756A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWorkable, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Workable.a99d086e.svg";
export { ForwardRef as ReactComponent };